/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ConfigRevision, NodeConfig } from '@/client';
import { NodeConfigsList } from '@/components/ConfigWizardOverlay/NodeConfigsList';
import { usePaginatedNodeConfigsQuery } from '@/hooks/query/usePaginatedNodeConfigsQuery';
import { Card } from '@/primitives/Card';

export type SelectConfigStepProps = {
  configsQuery: ReturnType<typeof usePaginatedNodeConfigsQuery>;
  selectedConfig: NodeConfig | undefined;
  onConfigSelect: (config: NodeConfig | undefined) => void;
  getNodeConfigPath: (config: NodeConfig) => string;
  getNodeConfigRevisionPath: (revision: ConfigRevision) => string;
};

export function SelectConfigStep({
  configsQuery,
  selectedConfig,
  onConfigSelect,
  getNodeConfigPath,
  getNodeConfigRevisionPath,
}: SelectConfigStepProps) {
  return (
    <Card dataTestId="fleet-wizard-select-config" padding="sm" bordered style={{ width: '100%' }}>
      <NodeConfigsList
        tags={[]}
        onFilterAndSortChange={configsQuery.updateQueryParams}
        nodeConfigsQuery={configsQuery}
        getNodeConfigPath={getNodeConfigPath}
        getNodeConfigurationRevisionPath={getNodeConfigRevisionPath}
        onNodeConfigSelect={onConfigSelect}
        defaultNodeConfig={selectedConfig}
      />
    </Card>
  );
}
